import { SurveyParticipationDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import type { FormFiltersStorage } from 'modules/forms'

/**
 * Hook to fetch participation metrics (sent/answered counts) with applied filters.
 * Used by both SurveyResponsesPage and SurveyOverviewPage.
 * Compatible with Rubén's new filter architecture.
 */
export function useParticipationData(
  formId: string,
  cycleIds: string[],
  filters: FormFiltersStorage['filters'] = {},
  shouldSkip?: boolean
) {
  const { data, loading } = useQuery(SurveyParticipationDocument, {
    variables: {
      formId,
      cycleIds,
      ...(filters.teamIds && Array.isArray(filters.teamIds) ? { teamIds: filters.teamIds } : {}),
      ...(filters.locationIds && Array.isArray(filters.locationIds)
        ? { locationIds: filters.locationIds }
        : {}),
      ...(filters.legalEntityIds && Array.isArray(filters.legalEntityIds)
        ? { legalEntityIds: filters.legalEntityIds }
        : {}),
      ...(filters.managerIds && Array.isArray(filters.managerIds)
        ? { managerIds: filters.managerIds }
        : {}),
      ...(filters.jobRoles && Array.isArray(filters.jobRoles)
        ? { jobRoles: filters.jobRoles }
        : {}),
      ...(filters.jobTitles && Array.isArray(filters.jobTitles)
        ? { jobTitles: filters.jobTitles }
        : {}),
    },
    skip: shouldSkip ?? false,
    fetchPolicy: 'cache-first',
  })

  return {
    sentCount: Number(data?.forms.total?.totalCount || 0),
    answeredCount: Number(data?.forms.answered?.totalCount || 0),
    cycleNode: data?.forms.cycles?.[0],
    loading,
  }
}
